import moment from 'moment';

export function invoiceVersion(invoiceDetail: any): 'v1' | 'v2' {
  const cutoffDate = moment('2024-10-01');
  const invoiceDate = moment(invoiceDetail.createdAt);
  if(cutoffDate.isBefore(invoiceDate)) return 'v2';
  if(invoiceDetail.qr) return 'v2';
  return 'v1';
}
